module.exports = {
  logoUrl: 'https://s3-ap-southeast-2.amazonaws.com/countmein-assets-dev/logo.png',
  adminGroupName: 'Admins',
  managerGroups: ['Admins', 'Management'],
};
